import { axiosBase, errorHandler } from './axios';

const saveLead = (data: any) => {
  return axiosBase.post('lead/save', data)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const listLeads = (params: any) => {
  return axiosBase.get('lead/list', { params })
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const viewLead = (id: string) => {
  return axiosBase.get(`lead/view/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const updateLead = (id: string, data: any) => {
  return axiosBase.put(`lead/update/${id}`, data)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const deleteLead = (id: string) => {
  return axiosBase.delete(`lead/delete/${id}`)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

const addFollowUp = (id: string, data: any) => {
  return axiosBase.post(`lead/followup/${id}`, data)
    .then(response => response.data)
    .catch(error => errorHandler(error));
};

export const leadService = {
  saveLead,
  listLeads,
  viewLead,
  updateLead,
  deleteLead,
  addFollowUp
};
